import "./App.scss";
import { Route, Routes, Navigate } from "react-router-dom";
import AuthProvider from "./auth/AuthProvider";
import { Layout, MainLayout } from "./components/layouts";
import LoginPage from "./pages/login/index";
import LoginErrorPage from "./pages/login/error";
import ContentErrorPage from "./pages/login/content-error";
import RegisterPage from "./pages/register";
import DashboardPage from "./pages/dashboard";
import WelcomePage from "./pages/welcome";
import "react-confirm-alert/src/react-confirm-alert.css";
import AnnouncementsPage from "./pages/announcements";
import CoursesPage from "./pages/courses";
import AllResourcesPage from "./pages/all-resources";
import ResourcesLessonsPage from "./pages/resources-lessons";
import MonthlyViewPage from "./pages/monthly-view";
import SecretPathPage from "./pages/secret-path";
import FriendsofDWFPage from "./pages/friends-of-dwf";
import DWFResourcesPage from "./pages/dwf-resources";
import FriendsOfDwfPartnerRoutePage from "./pages/friends-of-dwf/partner-page-route";
import ResourceSubmissionPage from "./pages/resource-submission";
import MessagesPage from "./pages/messages";
import ArtistAmbassadorSchedulingPage from "./pages/artist-ambassador-scheduling";
import ArtistAmbassadorEventsPage from "./pages/artist-ambassador-events";
import AmbassadorPage from "./pages/ambassador";
import { ARTIST_AMBASSADOR_SCHEDULING_ENABLED } from "./helpers/constants";
import SubmitaReconciliactionPage from "./pages/submit-a-reconciliaction";
import LegacySchoolsToolkitPage from "./pages/legacy-schools-toolkit";
import CollectionsIndexPage from "./pages/collections";
import CollectionPage from "./components/layouts/CollectionPage";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="app/dashboard" replace />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="login-error" element={<LoginErrorPage />} />
          <Route path="user-error" element={<ContentErrorPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="welcome" element={<WelcomePage />} />
          <Route path="ambassador" element={<AmbassadorPage />} />

          <Route path="app" element={<MainLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="announcements" element={<AnnouncementsPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="courses" element={<CoursesPage />} />
            <Route path="all-resources" element={<AllResourcesPage />} />
            <Route path="resources-lessons" element={<ResourcesLessonsPage />} />
            <Route path="monthly-view" element={<MonthlyViewPage />} />
            <Route path="secret-path" element={<SecretPathPage />} />
            <Route path="submit-a-reconciliaction" element={<SubmitaReconciliactionPage />} />
            <Route path="friends-of-dwf" element={<FriendsofDWFPage />} />
            <Route path="legacy-schools-toolkit" element={<LegacySchoolsToolkitPage />} />
            <Route
              path="friends-of-dwf/:partnerSlug"
              element={<FriendsOfDwfPartnerRoutePage />}
            />
            <Route path="collections" element={<CollectionsIndexPage />} />
            <Route path="collections/:collectionSlug" 
              element={<CollectionPage />} />
            <Route path="dwf-resources" element={<DWFResourcesPage />} />
            <Route path="resource-submission" element={<ResourceSubmissionPage />} />
            <Route path="artist-ambassador-events" element={<ArtistAmbassadorEventsPage />} />
            <Route
              path="artist-ambassador-scheduling/*"
              element={ARTIST_AMBASSADOR_SCHEDULING_ENABLED ? <ArtistAmbassadorSchedulingPage /> : <Navigate to="/app/dashboard" replace />}
            />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
